import { EntityStore } from '../../../shared/stores/EntityStore';
import { action, makeObservable } from 'mobx';
import { api } from '../../../shared/api/api';

class AssessmentStore extends EntityStore {
	constructor() {
		super('assessments');
		makeObservable(this);
	}

	@action
	async getAssessments(query) {
		const url = this.entityPluralEndpoint + '?q=' + query;
		const result = await api.get(encodeURI(url));
		return result;
	}
}

export const assessmentStore = new AssessmentStore();
